import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Promo' })({
    root: {
        padding: '96px 80px'
    },
    title: {
        margin: 0,
        color: '#fff',
        fontSize: 32,
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '-1.44px'
    },
    accent: {
        color: '#F5726A'
    }
});
